module.exports = __webpack_public_path__ + "ecc53062e5f910b98a994e6f75a2fdb3.png";